/* eslint-disable @typescript-eslint/no-empty-function */
import type { ReactNode } from 'react';
import type { DefaultTheme, StyledComponent } from 'styled-components';
import styled, { css } from 'styled-components';
import { variant } from 'styled-system';
import { TypographyVariant } from '../../utils/theme';
import Typography from '../typography/typography';

export enum BadgeVariant {
  Main = 'Main',
  Neutral = 'Neutral',
}

export interface IBadgeProps {
  variant: BadgeVariant;
  text: string | ReactNode;
}

export const Badge = ({
  variant = BadgeVariant.Main,
  text,
  ...rest
}: IBadgeProps) => {
  return text ? (
    <StyledBadge variant={variant} {...rest}>
      <BadgeText variant={TypographyVariant.labelSm} color="inherit">
        {text}
      </BadgeText>
    </StyledBadge>
  ) : undefined;
};

export default Badge;

const baseStyle = ({ theme }: { theme: DefaultTheme }) => css`
  width: 100%;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.palette.neutral['00']};
  border-radius: ${theme.borderRadius.sm};
  padding: 3px 4px;
  position: relative;
  height: 18px;
`;

const variantStyle = ({ theme }: { theme: DefaultTheme }) =>
  variant({
    variants: {
      [BadgeVariant.Main]: {
        backgroundColor: theme.palette.error.main,
        color: theme.palette.neutral['00'],
      },
      [BadgeVariant.Neutral]: {
        border: `1px solid ${theme.palette.neutral[70]}`,
        backgroundColor: theme.palette.neutral[50],
        color: theme.palette.neutral[100],
      },
    },
  });

const StyledBadge: StyledComponent<
  'div',
  DefaultTheme,
  Record<string, unknown>
> = styled('div')(baseStyle, variantStyle);

const BadgeText = styled(Typography)`
  flex-grow: 1;
`;
